var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"p-5",attrs:{"variant":"primary","fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":12}},[_c('h2',[_vm._v("Bienvenid@")]),_c('p')])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }